import React from 'react';
import Skeleton, { SkeletonCard } from '../Skeleton';
import './WorkersSkeleton.css';

const WorkersSkeleton = () => {
  return (
    <div className="workers-skeleton">
      {/* Page Header */}
      <div style={{ marginBottom: '24px' }}>
        <Skeleton variant="title" width="200px" height={32} style={{ marginBottom: '8px' }} />
        <Skeleton variant="text" width="280px" height={16} />
      </div>

      {/* Search Section */}
      <SkeletonCard style={{ marginBottom: '24px' }}>
        <Skeleton variant="rect" width="400px" height={40} />
      </SkeletonCard>

      {/* Workers Table */}
      <SkeletonCard>
        <Skeleton variant="title" width="150px" height={24} style={{ marginBottom: '20px' }} />

        {/* Table Header */}
        <div className="skeleton-workers-table-header">
          <Skeleton variant="text" width="20%" height={12} />
          <Skeleton variant="text" width="18%" height={12} />
          <Skeleton variant="text" width="15%" height={12} />
          <Skeleton variant="text" width="20%" height={12} />
          <Skeleton variant="text" width="18%" height={12} />
        </div>

        {/* Table Rows */}
        {[1, 2, 3, 4, 5, 6, 7, 8].map((row) => (
          <div key={row} className="skeleton-workers-table-row">
            <Skeleton variant="text" width="22%" height={14} />
            <Skeleton variant="rect" width="60px" height={28} style={{ borderRadius: '12px' }} />
            <Skeleton variant="text" width="12%" height={14} />
            <Skeleton variant="text" width="18%" height={14} />
            <Skeleton variant="button" width="140px" height={32} />
          </div>
        ))}

        {/* Pagination */}
        <div className="skeleton-workers-pagination">
          <Skeleton variant="text" width="120px" height={14} />
          <div style={{ display: 'flex', gap: '8px' }}>
            <Skeleton variant="button" width="80px" height={36} />
            <Skeleton variant="rect" width="40px" height={36} />
            <Skeleton variant="button" width="80px" height={36} />
          </div>
        </div>
      </SkeletonCard>
    </div>
  );
};

export default WorkersSkeleton;
